import { SvgIcon, SvgIconProps } from '@mui/material';

// black chevron with no background
const ChevronDownIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 18 12"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 12, height: 12, fill: 'none', ...sx }}
      data-testid="chevronDownIcon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.585786 1.08579C1.36683 0.304738 2.63317 0.304738 3.41421 1.08579L9 6.67157L14.5858 1.08579C15.3668 0.304738 16.6332 0.304738 17.4142 1.08579C18.1953 1.86683 18.1953 3.13317 17.4142 3.91421L10.4142 10.9142C9.63317 11.6953 8.36683 11.6953 7.58579 10.9142L0.585786 3.91421C-0.195262 3.13317 -0.195262 1.86683 0.585786 1.08579Z"
        fill="#0B1421"
      />
    </SvgIcon>
  );
};

export default ChevronDownIcon;
